import { APIResponse } from '@/types';
import {
    HistoryListRequestData,
    PpSummary,
    PpSummaryRequestData,
    StoreHistoryListResponse,
} from '@/types/pages/storeManagement/history';

import httpService from './../httpService';

export function handleFetchHistoryListAPI(
    data: HistoryListRequestData,
    options?: { signal?: AbortSignal },
): APIResponse<StoreHistoryListResponse> {
    return httpService.post('/history', data, { signal: options?.signal });
}

export function handleFetchPpSummaryAPI(data: PpSummaryRequestData): APIResponse<PpSummary> {
    return httpService.post('/history/pp', data);
}
